var _excluded = ["children", "container"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ReactDOM from 'react-dom';
import { useZIndexContext } from '../_hooks/ZIndex';
import { StyledPortal } from './Portal.styles';
/**
 * @deprecatedSince 11
 * @deprecated Intended for internal library development.
 * @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_coverage-portal--defaults)
 */
export function Portal(_ref) {
  var children = _ref.children,
    container = _ref.container,
    props = _objectWithoutProperties(_ref, _excluded);
  var zIndexCtx = useZIndexContext();
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(StyledPortal, _extends({}, props, {
    style: {
      zIndex: zIndexCtx.value
    }
  }), children), container || document.body);
}
//# sourceMappingURL=Portal.js.map